import { BusinessDownloadConfig } from '../types';
import { publisherCheckboxList, publisherCheckboxListNoRegion } from './common';

const pcConfig: BusinessDownloadConfig = {
  'pc-console-detail-store-rank': {
    apiUrl: 'api/v1/intelligence_pc/detail/stats/metrics/store_rank/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'source_type',
        defaultValue: ['steam'],
        options: [],
        // options: [
        //   { label: 'Steam', value: 'steam' },
        //   { label: 'Epic', value: 'epic' },
        //   { label: 'Playstation', value: 'play_station' },
        //   { label: 'Xbox', value: 'xbox' },
        //   { label: 'Nintendo', value: 'nintendo' },
        // ],
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          company_show: false,
          genre_show: false,
          release_date_show: false,
          region_show: false,
          steam_id_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
          { label: 'dbi_release_date', value: 'release_date_show' },
          { label: 'dbi_steam_id', value: 'steam_id_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'date_method',
            options: [{ label: 'dbi_label_separate_by_time_combine', value: 'separate' }],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'market',
            options: [
              // { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
            ],
          },
          // {
          //   label: 'dbi_label_ratio',
          //   type: 'switch',
          //   defaultValue: true,
          //   field: 'ratio_show',
          //   options: [],
          // },
        ],
      },
    ],
  },
  'pc-console-detail-store-rank-market-count': {
    apiUrl: 'api/v1/intelligence_pc/detail/stats/metrics/store_rank/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      publisherCheckboxListNoRegion,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'date_method',
            options: [{ label: 'dbi_label_separate_by_time_combine', value: 'separate' }],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
        ],
      },
    ],
  },
};

export default pcConfig;
